export default __webpack_public_path__ + "static/media/resolve.48c32a3a.png";